var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon06(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.79941 4.45002H26.1494C26.7494 4.45002 27.2994 3.95002 27.2994 3.30002C27.2994 2.65002 26.7994 2.15002 26.1494 2.15002H5.79941C5.19941 2.15002 4.64941 2.65002 4.64941 3.30002C4.64941 3.95002 5.19941 4.45002 5.79941 4.45002Z",
    fill: "url(#paint0_linear_272_9895)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.9 12.9H28.1C28.7 12.9 29.25 12.4 29.25 11.75C29.25 11.1 28.75 10.6 28.1 10.6H3.9C3.3 10.6 2.75 11.1 2.75 11.75C2.75 12.4 3.3 12.9 3.9 12.9Z",
    fill: "url(#paint1_linear_272_9895)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74961 19.1C7.14961 19.1 6.59961 19.6 6.59961 20.25C6.59961 20.9 7.09961 21.4 7.74961 21.4H24.2996C24.8996 21.4 25.4496 20.9 25.4496 20.25C25.4496 19.6 24.9496 19.1 24.2996 19.1H7.74961Z",
    fill: "url(#paint2_linear_272_9895)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9996 27.55H1.99961C1.39961 27.55 0.849609 28.0501 0.849609 28.7001C0.849609 29.3501 1.34961 29.85 1.99961 29.85H29.9996C30.5996 29.85 31.1496 29.3501 31.1496 28.7001C31.1496 28.0501 30.5996 27.55 29.9996 27.55Z",
    fill: "url(#paint3_linear_272_9895)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_272_9895",
    x1: 15.9744,
    y1: 2.15002,
    x2: 15.9744,
    y2: 4.93664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.744792,
    stopColor: "white",
    stopOpacity: 0.364583
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_272_9895",
    x1: 16,
    y1: 10.6,
    x2: 16,
    y2: 13.3866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.744792,
    stopColor: "white",
    stopOpacity: 0.364583
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_272_9895",
    x1: 16.0246,
    y1: 19.1,
    x2: 16.0246,
    y2: 21.8866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.744792,
    stopColor: "white",
    stopOpacity: 0.364583
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_272_9895",
    x1: 15.9996,
    y1: 27.55,
    x2: 15.9996,
    y2: 30.3367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.744792,
    stopColor: "white",
    stopOpacity: 0.364583
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon06);
export default __webpack_public_path__ + "static/media/icon-06.0208eb1ac8a4df6cca7954165a719b5c.svg";
export { ForwardRef as ReactComponent };